import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { PERMISSIONS_CASH_BOX } from '../../../../../../../utility/SourceAPI'

export const getPermissionsToAssign = createAsyncThunk('appCashBoxPermissions/getPermissionsToAssign', async (data) => {
    const response = await axios.get(PERMISSIONS_CASH_BOX.concat(`?user_by_id=${data}`))
    return response.data
})

export const addPermissionToAssign = createAsyncThunk('appCashBoxPermissions/addPermissionToAssign', async (data) => {
    const response = await axios.post(PERMISSIONS_CASH_BOX, data)
    return response.data
})

export const permissionsToAssignSlice = createSlice({
    name: 'appCashBoxPermissions',
    initialState: {
        data: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPermissionsToAssign.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(getPermissionsToAssign.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload.data
            })
            .addCase(getPermissionsToAssign.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })
    }
})

export default permissionsToAssignSlice.reducer